export const GIFT_CARD = 'Gift Card';
export const DELIVERY = 'DELIVERY';
export const PICKUP = 'PICKUP';
export const CATERING = 'CATERING';
